import React from 'react';
import {
  Typography,
  Card,
  CardContent,
  Box,
  Chip,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import { ChatProviderResponse } from '@/api/ApiClient';

interface ProvidersTabProps {
  providers: ChatProviderResponse[];
}

export default function ProvidersTab({ providers }: ProvidersTabProps) {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        {t('chatConfig.providers.title')}
      </Typography>
      <Grid container spacing={2}>
        {providers.map((provider) => (
          <Grid size={{ xs: 12, md: 6 }} key={provider.value}>
            <Card>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                  <Typography variant="h6">{provider.label}</Typography>
                  {provider.is_active && (
                    <Chip label="Active" color="success" size="small" />
                  )}
                </Box>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  {provider.description}
                </Typography>
                
                <Typography variant="body2" sx={{ mt: 1, fontWeight: 'bold' }}>
                  {t('chatConfig.providers.features')}:
                </Typography>
                <Typography variant="body2">
                  {provider.features?.join(', ') || 'N/A'}
                </Typography>
                
                <Typography variant="body2" sx={{ mt: 1, fontWeight: 'bold' }}>
                  {t('chatConfig.providers.supportedModels')}:
                </Typography>
                <Typography variant="body2">
                  {provider.default_models?.join(', ') || provider.default_model || 'N/A'}
                </Typography>
                
                <Typography variant="body2" sx={{ mt: 1, fontWeight: 'bold' }}>
                  {t('chatConfig.providers.configFields')}:
                </Typography>
                <Typography variant="body2">
                  {provider.required_config?.join(', ') || 'None'}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}